import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  InputRightElement,
  InputGroup,
  FormLabel,
  Input,
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,
} from "@chakra-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import { BiHide, BiShow } from "react-icons/bi";
import { updateUserPassword } from "../../../api/user.service";

const ChangePassword = () => {
  const [newPassword, setNewPassword] = React.useState();
  const [oldPassword, setOldPassword] = React.useState();
  const [isOpen, setIsOpen] = React.useState();
  const [confirmPassword, setConfirmPassword] = React.useState();
  const [show, setShow] = React.useState(false);
  const [passwordData, setPasswordData] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  const onClose = () => setIsOpen(false);
  const cancelRef = React.useRef();

  const toast = useToast();

  const {
    state: { profile },
  } = useLocation();

  const history = useHistory();

  const { register, handleSubmit, errors, formState } = useForm();

  const checkPassword = (value) => {
    let error;
    if (value !== newPassword) {
      error = "Password are different.";
    }
    return error || true;
  };

  const checkOldPassword = (value) => {
    let error;
    if (value === oldPassword) {
      error = "Password cannot be the same as old one";
    }
    return error || true;
  };

  const handleClick = () => setShow(!show);

  const submitPasswordChange = async () => {
    try {
      setIsLoading(true);
      const { data } = await updateUserPassword(passwordData);
      setIsLoading(false);
      data && onClose();
      history.push("/dashboard/me");
      toast({
        title: "Password Change",
        description: "You have successfully changed your password",
        isClosable: true,
        position: "top",
        duration: 2500,
      });
    } catch (error) {
      error &&
        toast({
          title: "Password Change",
          description: "Password change failed.",
          isClosable: true,
          position: "top",
          duration: 2500,
          status: "error",
        });
    }
  };

  const onSubmit = async (values) => {
    setIsOpen(true);
    setPasswordData(values);
  };

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            Change Password
          </AlertDialogHeader>

          <AlertDialogBody>
            Are you sure? You can't undo this action afterwards.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancel
            </Button>
            <Button
              variantColor='red'
              onClick={submitPasswordChange}
              ml={3}
              isLoading={isLoading}
            >
              Change Password
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <Box height='100%' w={["100%", "70%"]} mx='auto'>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            flex='1'
            w='100%'
          >
            <Text
              fontWeight='700'
              textAlign='center'
              fontSize='xl'
              my={["2", "8"]}
            >
              Change Password
            </Text>
            <Flex
              direction='column'
              width='100%'
              height={["auto", "80%"]}
              boxShadow='md'
              border='1px solid #EDF2F7'
              p={["0", "4"]}
            >
              <Box
                display='flex'
                flexDirection={["column", "row"]}
                rounded='10px'
              >
                <Box flex='1' m='10px'>
                  <FormControl mt='15px'>
                    <FormLabel htmlFor='email'>Email</FormLabel>
                    <Input
                      defaultValue={profile.email}
                      placeholder='Enter your email'
                      name='email'
                      ref={register}
                    />
                  </FormControl>
                  <FormControl mt='20px'>
                    <FormLabel
                      htmlFor='old_password'
                      isInvalid={errors.old_password}
                    >
                      Old Password
                    </FormLabel>
                    <InputGroup size='md'>
                      <Input
                        type={show ? "text" : "password"}
                        placeholder='Enter old password'
                        name='old_password'
                        ref={register({ required: "Field is required" })}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                      <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='md' onClick={handleClick}>
                          {show ? <BiHide /> : <BiShow />}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                  </FormControl>

                  <FormControl mt='20px' isInvalid={errors.new_password}>
                    <FormLabel htmlFor='new_password'>New Password</FormLabel>
                    <InputGroup size='md'>
                      <Input
                        type={show ? "text" : "password"}
                        name='new_password'
                        placeholder='Enter new password'
                        ref={register({
                          required: "Field is required",
                          validate: checkOldPassword,
                        })}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='md' onClick={handleClick}>
                          {show ? <BiHide /> : <BiShow />}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage>
                      {errors.new_password && errors.new_password.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    flex='1'
                    mt='20px'
                    isInvalid={errors.new_password_confirmation}
                  >
                    <FormLabel htmlFor='new_password_confirmation'>
                      Confirm New Password
                    </FormLabel>
                    <InputGroup size='md'>
                      <Input
                        type={show ? "text" : "password"}
                        placeholder='Enter password'
                        name='new_password_confirmation'
                        ref={register({
                          required: "Confirm your password",
                          validate: checkPassword,
                        })}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='md' onClick={handleClick}>
                          {show ? <BiHide /> : <BiShow />}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage>
                      {errors.new_password_confirmation &&
                        errors.new_password_confirmation.message}
                    </FormErrorMessage>
                  </FormControl>
                </Box>
              </Box>
            </Flex>
            <Box
              display='flex'
              justifyContent='center'
              alignItems='center'
              flex='1'
              w='100%'
            >
              <Button
                type='submit'
                variantColor='green'
                color='white'
                size='lg'
                size='md'
                height='48px'
                width={["100%", "300px"]}
                _focus='none'
                my='5'
                isLoading={formState.isSubmitting}
              >
                Update
              </Button>
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ChangePassword;
